/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { splitQuery } from '../../Shares/CommonUtil';
import { RouletteApi } from '../../Utils/Api/RouletteApi';
import { cdnUrlConfig } from '../../Utils/atoms';
import { initUnity, setUnityMember } from '../../Utils/unityUtil';
import PrizePopUp from './PopUp/PrizePopUp';
import GifticonPopUp from './PopUp/GifticonPopUp';
import { EventApi } from '../../Utils/Api/EventApi';

const ROTATE_SECONDS = 1000 * 6; //회전시간

const RouletteMain = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;
	const alert = useAlert();
	const [_rewardResult, setRewardResult] = useState({}); //룰렛결과 오브젝트
	const [_rewardLog, setRewardLog] = useState({}); //룰렛결과 로그
	const [attendance, setAttendance] = useState(false);
	const [walking, setWalking] = useState(false);
	const [advertise, setAdvertise] = useState(false);
	const [rouletteCount, setRouletteCount] = useState(0);
	const [degree, setDegree] = useState(0);
	const [member_se, setMemberSe] = useState(0);
	const [isRotate, setIsRotate] = useState(false);

	// 팝업
	const [prizePopUp, setPrizePopUp] = useState(0); // 젤리, 하트 팝업
	const [gifticonPopUp, setGifticonPopUp] = useState(0); // 나의 당첨내역

	// 주소에서 event_se 가져오기
	const { search } = useLocation();
	const querys = splitQuery(search);
	const event_se = querys['event_se'] ? querys['event_se'] : 0;

	// 믹스패널용 이벤트 정보
	const [eventName, setEventName] = useState('');
	const [eventCategoryType, setEventCategoryType] = useState('');

	// 카테고리 코드에 따른 카테고리 명을 반환한다
	const getEventCategoryName = (category_cd) => {
		let result = '';
		if (category_cd === 0) {
			result = '기본';
		} else if (category_cd === 1) {
			result = '룰렛';
		} else if (category_cd === 2) {
			result = '캡슐';
		}

		return result;
	};

	// member_se 호출에 실패했을 경우의 안내 팝업
	const showErrorAlert = (message) => {
		alert.error(message, {
			timeout: 5000, // 5 seconds
		});
	};

	// Unity 함수 호출
	useEffect(() => {
		if (event_se > 0) {
			initUnity();
			setUnityMember(
				(member_se) => setMemberSe(member_se),
				(msg) => showErrorAlert(msg)
			);
		}
	}, []);

	// GET 이벤트 상세 정보 API
	useEffect(() => {
		EventApi.GetEventStatus(event_se).then((response) => {
			const { status, data } = response;
			if (status === 200) {
				setEventName(data.data.event_nm);
				setEventCategoryType(
					getEventCategoryName(data.data.event_category_cd)
				);
			}
		})
		.catch(error => {
			const { status, data } = error.response;
			if (status === 404) {
				alert.error(data.msg, {
					timeout: 10000, // 10 seconds
				});
			}
		});
	}, [event_se]);

	// GET 룰렛 응모권
	useEffect(() => {
		if (member_se > 0) {
			RouletteApi.GetRouletteCount(event_se, member_se).then((response) => {
				const {
					status,
					data: { attendance, walking, advertise, roulette_count },
				} = response;
				if (status === 200) {
					setAttendance(attendance);
					setWalking(walking);
					setAdvertise(advertise);
					setRouletteCount(roulette_count);
				}
			});
		}
	}, [member_se]);

	// 상품 종류에 따른 룰렛판 각도 style 설정
	const styleRotate = {
		transform: degree === 0 ? '' : `rotate(${7200 + degree}deg)`,
		transition: `transform ${degree === 0 ? '0' : ROTATE_SECONDS}ms ease`, // smooth transition
	};

	// 룰렛을 돌려서 결과를 반환
	const rotateRoulette = () => {
		if (isRotate) {
			return;
		}
		setDegree(0);
		if (member_se > -1 && rouletteCount > 0) {
			setIsRotate(true);
			const data = { event_se: event_se, member_se: member_se };
			RouletteApi.PostRotateRoulette(data).then((response) => {
				const {
					status,
					data: { rewardResult, rewardLog, degree },
				} = response;
				if (status === 200) {
					setRewardResult(rewardResult);
					setRewardLog(rewardLog);
					setRouletteCount((prev) => prev - 1);
					setDegree(degree);
					setTimeout(() => {
						setPrizePopUp(1);
						setIsRotate(false);
					}, ROTATE_SECONDS);
				}
				window.MixPanelCompleteEvent(
					eventName,
					eventCategoryType,
					rewardResult.event_reward_info_nm
				);
			});
		}
	};

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content Roulette'>
					<div className='visual'>
						<h1>
							<img
								src={`${IMG_URL}/images/roulette/tit.png`}
								alt='힙-스터 망고의 무조건 당첨 룰렛이벤트'
							/>
						</h1>
						<p className='date'>
							<span>11.20 - 12.07</span>
						</p>
						<div className='roulette-box'>
							<div className='roulette-area'>
								<div className='roulette'>
									<img
										style={styleRotate}
										src={`${IMG_URL}/images/roulette/img_roulette.png`}
										alt='룰렛'
									/>
								</div>
								{member_se > 0 && (
									<button
										className={
											'btn-start'
										}
										onClick={() => {
											window.MixPanelClickEventButton(
												eventName,
												eventCategoryType
											);
											rotateRoulette();
										}}
									>
										start
									</button>
								)}
							</div>
							<p className='my-ticket'>
								나의 응모권{' '}
								<span className='count'>
									{rouletteCount < 0 ? 0 : rouletteCount}
								</span>
								장
							</p>
							{gifticonPopUp !== 0 && (
								<>
									<GifticonPopUp
										close={() => setGifticonPopUp(0)}
										eventSe={event_se}
										memberSe={member_se}
										rewardLog={_rewardLog}
									/>
								</> 
							)}
							{prizePopUp !== 0 && (
								<PrizePopUp
									rewardResult={_rewardResult}
									close={() => setPrizePopUp(0)}
								/>
							)}
						</div>
					</div>
					<div className='event-info product'>
						<div className='tit-area'>
							<h2>무조건 당첨 경품 리스트!</h2>
						</div>
						<ul className="clear">
							<li>
								<div className="product">
									<div className="num">3명</div>
									<div className='photo'>
										<img
											src={`${IMG_URL}/images/roulette/product_1.png`}
											alt='올리브영 기프트카드'
										/>
									</div>
								</div>
								<dl>
									<dt>올리브영 기프트카드</dt>
									<dd>50,000원 권</dd>
								</dl>
							</li>
							<li>
								<div className="product">
									<div className="num">10명</div>
									<div className='photo'>
										<img
											src={`${IMG_URL}/images/roulette/product_2.png`}
											alt='CU 모바일 금액권'
										/>
									</div>
								</div>
								<dl>
									<dt>CU 모바일 금액권</dt>
									<dd>5,000원 권</dd>
								</dl>
							</li>
							<li>
								<div className="product">
									<div className="num">30명</div>
									<div className='photo'>
										<img
											src={`${IMG_URL}/images/roulette/product_3.png`}
											alt='다이소 모바일 금액권'
										/>
									</div>
								</div>
								<dl>
									<dt>다이소 모바일 금액권</dt>
									<dd>3,000원 권</dd>
								</dl>
							</li>
						</ul>
						<div className="money-list">
							<div className="money-box">
								<div className="tag">무제한</div>
								<div className="photo">
									<img
										src={`${IMG_URL}/images/roulette/product_5.png`}
										alt='젤리'
									/>
								</div>
								<dl>
									<dt>젤리</dt>
									<dd>600개</dd>
								</dl>
							</div>
							<div className="money-box">
								<div className="tag">무제한</div>
								<div className="photo">
									<img
										src={`${IMG_URL}/images/roulette/product_6.png`}
										alt='젤리'
									/>
								</div>
								<dl>
									<dt>젤리</dt>
									<dd>300개</dd>
								</dl>
							</div>
							<div className="money-box">
								<div className="tag">무제한</div>
								<div className="photo">
									<img
										src={`${IMG_URL}/images/roulette/product_4.png`}
										alt='하트'
									/>
								</div>
								<dl>
									<dt>하트</dt>
									<dd>15개</dd>
								</dl>
							</div>
						</div>
						{member_se !== 1 && (
							<button
								className='btn-prize'
								onClick={() => setGifticonPopUp(1)}
							>
								나의 당첨내역 보기 &gt;
							</button>
						)}
					</div>
					<div className='event-info howto'>
						<div className='tit-area'>
							<h2>룰렛 응모권 얻는 방법!</h2>
						</div>
						<ol>
							<li className={attendance ? 'on' : ''}>
								<div className="num">01</div>
								<div className="cnt">
									<dl>
										<dt>출석체크 완료하기 X1</dt>
										<dd>펫룸&gt;출석부&gt;출석 보상 받기</dd>
									</dl>									
								</div>
							</li>
							<li className={walking ? 'on' : ''}>
								<div className="num">02</div>
								<div className="cnt">
									<dl>
										<dt>산책 완료하기 X2</dt>
										<dd>펫룸&gt;펫 클릭&gt;산책하기</dd>
									</dl>									
								</div>
							</li>
							<li className={advertise ? 'on' : ''}>
								<div className="num">03</div>
								<div className="cnt">
									<dl>
										<dt>충전소 광고 시청하기 X2</dt>
										<dd>충전소&gt;광고보기</dd>
									</dl>
									<button onClick={() => window.GoToFactory()}>
										<span>광고 보러 바로가기</span>
									</button>
								</div>
							</li>
						</ol>
					</div>
					<div className='cautionary'>
						<dl>
							<dt>확인해주세요!</dt>
							<dd>본 이벤트는 2023년 11월 20일부터 12월 07일까지 진행됩니다.</dd>
							<dd>기프티콘 경품에 당첨되신 당첨자께서는 반드시 휴대 전화번호를 입력해주서야 합니다.</dd>
							<dd>미 입력시 당첨 내역보기를 눌러서 전화번호 입력란에 입력해주셔야 됩니다.</dd>
							<dd>12월 07일까지 미 입력시 당첨이 무효 처리됩니다.</dd>
							<dd>이벤트 경품은 12월 07일 이후 일괄 발송될 예정입니다.</dd>
							<dd>기프티콘 상품은 교환/환불/연장이 불가합니다.</dd>
							<dd>해당 이벤트는 앱스토어 또는 구글 플레이스토어등과 무관합니다.</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
	);
};

export default RouletteMain;
